var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{style:({margin: _vm.margin, borderColor: _vm.borderColor})},[_c('label',{attrs:{"for":"upload-photo"}},[_vm._v(_vm._s(_vm.label))]),_c('input',{attrs:{"type":"file","name":"photo","id":"upload-photo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }